<template>
  <div
    class="
      d-flex
      flex-column flex-sm-row
      justify-content-end
      homebase-modal-footer
      px-5
      pb-5
    "
  >
    <div v-for="(buttonConfig, i) in buttonConfigs" :key="i">
      <div
        :class="buttonConfig.class"
        class="mt-2 ml-sm-4"
        @click="buttonConfig.clickHandler"
      >
        {{ buttonConfig.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal-footer",
  props: ["buttonConfigs"],
};
</script>



// WEBPACK FOOTER //
// src/components/homebase/modals/ModalFooter.vue